import { getTransactionsByType } from '../transaction/selectors';
import { getAddress } from '../wallet/selectors';
import { AUTHORIZATION_FLOW_REQUEST, GRANT_TOKEN_SUCCESS } from './actions';
import { AuthorizationType } from './types';
export const getState = state => state.authorization;
export const getData = (state) => getState(state).data;
export const getLoading = (state) => getState(state).loading;
export const isLoading = (state) => getLoading(state).length > 0;
export const getError = (state) => getState(state).error;
export const getAuthorizationFlowError = (state) => getState(state).authorizationFlowError;
export const getTransactions = (state) => getTransactionsByType(state, getAddress(state) || '', GRANT_TOKEN_SUCCESS);
export const getAllowTransactions = (state) => getTransactions(state).filter(transaction => transaction.payload.authorization.type === AuthorizationType.ALLOWANCE);
export const getApproveTransactions = (state) => getTransactions(state).filter(transaction => transaction.payload.authorization.type === AuthorizationType.APPROVAL);
export const isAuthorizing = (state) => getLoading(state).some(loading => loading.type === AUTHORIZATION_FLOW_REQUEST);
//# sourceMappingURL=selectors.js.map